export default __webpack_public_path__ + "static/media/logo-dark.51fee3e4.png";